import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { AdjustmentFilterEntity } from '../../domain/entities/AdjustmentFilterEntity'

export class AdjustmentFilterModel extends AdjustmentFilterEntity {
  constructor(dataDto: AdjustmentFilterEntity) {
    super()
    mapEntityProperties<AdjustmentFilterModel>(this, dataDto)
  }
}
